import { readDecorLook, type DecorLook } from '@peles/shared';
import type { DressableItem } from '../decor-library/ObjectDecorControl';
import { resolveProfile } from './three-d';
import type { CanvasItem } from './types';

/**
 * An object on the plan as the decor library sees it: its type, and whether
 * the 3D view lays it as a table (with linen, chairs and place settings).
 */
export function dressableOf(item: CanvasItem): DressableItem {
  return {
    objectType: item.objectType,
    isTable: resolveProfile(item).kind === 'TABLE',
    config: item.config ?? null,
  };
}

/** An object with its own look set, or taken away (null) so it follows the plan. */
export function withItemDecor(item: CanvasItem, decor: DecorLook | null): CanvasItem {
  const config = { ...(item.config ?? {}) };
  const clean = decor ? readDecorLook(decor) : null;
  if (clean && Object.keys(clean).length) config.decor = clean;
  else delete config.decor;
  return { ...item, config };
}

/** What an object is called in "Decor for …". */
export function itemDecorName(item: CanvasItem): string {
  if (item.tableNumber != null) return `Table ${item.tableNumber}`;
  return item.label || item.objectType.toLowerCase().replace(/_/g, ' ');
}
